import script from "./CreateEmployee.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateEmployee.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__